var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-type-container" },
    [
      _c("automation-type-header", {
        attrs: {
          trigger: _vm.trigger,
          "title-properties": _vm.typeHeaderTitleProperties,
          "board-level": _vm.level,
        },
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.isCollapsed
          ? _c(
              "div",
              { staticClass: "card" },
              [
                _vm.levelIs("board")
                  ? _c("div", { staticClass: "row no-gutters" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-lg-6 my-automations-left-column",
                        },
                        [
                          _c("div", {
                            staticClass:
                              "column-divider-top d-lg-none d-sm-block",
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-header px-4 pt-4" }, [
                            _c("h5", { staticClass: "p-0 bold" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "automations.boardLevel.myAutomations"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "h6",
                              {
                                staticClass:
                                  "text-primary bold text-uppercase automation-subtitle",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "automations.boardLevel.automationsOnlyICanTrigger"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("automation-list", {
                            attrs: {
                              "share-type": "personal",
                              automations: _vm.automations,
                              level: _vm.level,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-lg-6" },
                        [
                          _c("div", {
                            staticClass:
                              "column-divider-top d-lg-none d-sm-block",
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-header px-4 pt-4" }, [
                            _vm.canBeShared && _vm.existSharedAutomations
                              ? _c(
                                  "h5",
                                  { staticClass: "p-0 bold" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "automations.boardLevel.sharedAutomations"
                                          )
                                        ) +
                                        "\n              " +
                                        _vm._s(_vm.$t("global.words.on")) +
                                        "\n              "
                                    ),
                                    _c("boards-dropdown", {
                                      attrs: {
                                        id: "boards",
                                        items: _vm.boardsRelated,
                                        "inherit-font-size": true,
                                        placeholder: _vm.$t(
                                          "boards.actions.selectBoard"
                                        ),
                                        "button-class": "text-primary ml-2",
                                        "class-prefix": "board--",
                                      },
                                      model: {
                                        value: _vm.currentBoard,
                                        callback: function ($$v) {
                                          _vm.currentBoard = $$v
                                        },
                                        expression: "currentBoard",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("h5", { staticClass: "p-0 bold" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "automations.boardLevel.sharedAutomations"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                            _vm._v(" "),
                            _c(
                              "h6",
                              {
                                staticClass:
                                  "text-primary bold text-uppercase automation-subtitle",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "automations.boardLevel.automationsAnyCollaboratorCanTrigger"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("automation-list", {
                            attrs: {
                              "share-type": "shared",
                              automations: _vm.automations,
                              "board-filter": _vm.currentBoard,
                              level: _vm.level,
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _c("automation-list", {
                      attrs: { automations: _vm.automations, level: _vm.level },
                    }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }